var map = {
	"./Background.jpg": "b668",
	"./Bottom_Image.jpg": "d832",
	"./Joy-Stick-Emoji.png": "f104",
	"./Mando-Emoji.png": "3e3f",
	"./Play_Film_mage.jpg": "93cc",
	"./Space-Invaders-Emoji.png": "cfc3",
	"./Square_1.jpg": "a54e",
	"./Square_2.jpg": "797b",
	"./Square_3.jpg": "69aa",
	"./Square_4.jpg": "ea53",
	"./ezgif.com-optimize.gif": "80c5",
	"./ezgif.com-optimize_1.gif": "9a84",
	"./ezgif.com-optimize_2.gif": "6274",
	"./ezgif.com-optimize_3.gif": "1229",
	"./splash.jpg": "e840"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c68e";